import { HandHeart, SlidersHorizontal, Sparkles } from "lucide-react";
import { StepShell, BottomBar, PrimaryButton } from "./ui";

const PLURAL = { Apartment: "Apartments", "Villa / Row house": "Villas and row houses", Plot: "Plots", Commercial: "Commercial spaces" };

export const WiderSearch = ({ answers, onRequest, onChange, onBack }) => {
  const needs = [answers.configuration, answers.property_type, answers.area || answers.city, answers.budget].filter((v) => v && v !== "Not decided yet");
  const kind = PLURAL[answers.property_type] || "Properties";
  const decided = answers.city && answers.city !== "Not decided yet";
  const place = decided ? `${answers.area && answers.area !== "Not decided yet" ? `${answers.area}, ` : ""}${answers.city}` : "India";
  return (
    <StepShell stepKey="results" onBack={onBack} testId="screen-wider-search">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--saffron-deep)]"><Sparkles className="h-4 w-4" /> Namaste — good news</p>
      <h2 className="mt-2 font-display text-[1.8rem] font-medium leading-tight text-[#1f2328] sm:text-4xl" data-testid="wider-search-heading">
        {kind} like this are available in {place}.
      </h2>
      <p className="mt-3 font-display text-xl text-[#0f6d06]" data-testid="wider-search-promise">Our team will shortlist 5–7 for you.</p>
      <p className="mt-3 text-[15px] text-neutral-600" data-testid="wider-search-copy">
        We'll pick the closest RERA-registered, NRI-friendly options from our network, and prepare a MatchMaking presentation for each so you can explore them from wherever you are.
      </p>
      {needs.length > 0 && (
        <ul className="mt-6 flex flex-wrap gap-2" data-testid="wider-search-needs">
          {needs.map((n) => <li key={n} className="rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-sm text-[#1f2328]">{n}</li>)}
        </ul>
      )}
      <div className="mt-8 flex gap-3 rounded-3xl border border-[#138808]/30 bg-[#138808]/[0.04] p-5">
        <HandHeart className="h-6 w-6 shrink-0 text-[#138808]" />
        <p className="text-sm text-[#1f2328]">You'll receive MatchMaking presentations for your shortlist by email and on WhatsApp chat within 24 hours. We never call.</p>
      </div>
      <div className="h-40" />
      <BottomBar>
        <div className="space-y-2.5">
          <PrimaryButton onClick={onRequest} data-testid="request-personal-matchmaking-button">
            <HandHeart className="h-5 w-5" /> Request MatchMaking
          </PrimaryButton>
          <button type="button" onClick={onChange} className="flex min-h-[44px] w-full items-center justify-center gap-2 rounded-full border border-neutral-300 bg-white text-sm font-semibold text-[#1f2328]" data-testid="wider-search-change-button">
            <SlidersHorizontal className="h-4 w-4" /> Change my search
          </button>
        </div>
      </BottomBar>
    </StepShell>
  );
};
